import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import logo from '../../assets/logos/cetificated-no-border.png';
import { useLang } from '../../context/LangContext';

import enTexts from '../../translations/en.json';
import esTexts from '../../translations/es.json';
import axios from 'axios';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import packageJson from '../../../package.json';

const Footer = () => {
  const { lang } = useLang();
  const [texts, setTexts] = useState(lang === 'es' ? esTexts : enTexts);
  const { token } = useContext(AuthContext);

  const [contactInfo, setContactInfo] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [enviando, setEnviando] = useState(false);
  const [logos, setLogos] = useState([]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setContactInfo(prevInfo => ({ ...prevInfo, [name]: value }));
  };

  const getAllLogos = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/${lang}/logos`);

      if (response.status === 200) {
        setLogos(response.data.logos);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendContactMessage = async () => {
    setEnviando(true);
    const { name, email, message } = contactInfo;

    if (!name || !email || !message) {
      alert(texts.contactForm.messageEmpty);
      setEnviando(false);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/es/sendContactMessage`,
        { name, email, message }
      );

      alert(response.data.message);
    } catch (error) {
      const { response } = error;
      alert(response.data.message);
    } finally {
      setEnviando(false);
      setContactInfo({ name: '', email: '', message: '' });
    }
  };

  useEffect(() => {
    getAllLogos();
  }, []);

  const [mobileSlides, setMobileSlides] = useState(2);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setMobileSlides(2);
      } else if (window.innerWidth <= 768) {
        setMobileSlides(3);
      } else {
        setMobileSlides(logos.length > 5 ? 5 : logos.length);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [logos.length]);

  return (
    <>
      <div className="bg-dark text-center pt-3 pb-1 mt-0">
        <div className="container mb-5">
          <div className="row text-white ps-3 ps-sm-0">
            <div className="col-12 col-sm-2 text-start">
              <div className="d-flex flex-row flex-sm-column align-items-center align-items-sm-start mb-0 mb-sm-0">
                <img src={logo} alt="Logo 1" className="mb-0 mb-sm-4 d-none d-sm-block" />
                <img
                  src={logo}
                  alt="Logo 1"
                  className="mb-0 me-4 d-block d-sm-none"
                  style={{ width: '80px' }}
                />
                <div>
                  <a
                    href="https://wa.me/56992774127"
                    className="text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-2x fa-whatsapp me-3"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/alojamientoscertificados?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    className="text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-2x fa-instagram me-3"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/alojamientos-certificados/"
                    target="_blank"
                    className="text-white"
                    rel="noreferrer"
                  >
                    <i className="fa fa-2x fa-linkedin"></i>
                  </a>
                </div>
              </div>
              <p className="mt-4" style={{ fontSize: '0.7rem' }}>
                <i className="fa fa-envelope me-1"></i> info@alojamientoscertificados.cl
              </p>
            </div>
            <div className="col-12 col-sm-10 text-start pt-5">
              {texts.sponsored_by}:<br />
              <br />
              <div className="me-sm-0 px-0 px-sm-4">
                {logos.length > 0 && (
                  <Slider
                    infinite={true}
                    slidesToShow={mobileSlides}
                    slidesToScroll={mobileSlides === 2 ? 2 : 1}
                    autoplay={true}
                    autoplaySpeed={3000}
                    arrows={false}
                  >
                    {logos.map((logo, index) => (
                      <div
                        key={index}
                        className="px-0 px-sm-2 text-center d-flex justify-content-center align-items-center"
                      >
                        <img
                          src={logo.url}
                          alt={`Logo ${index}`}
                          className="logo-footer mx-auto cursor-pointer"
                          style={{
                            maxHeight: '120px',
                            objectFit: 'contain',
                            width: '100%',
                          }}
                          onClick={logo.web ? () => window.open(logo.web, '_blank') : undefined}
                        />
                      </div>
                    ))}
                  </Slider>
                )}
              </div>
            </div>
            <hr className="mx-2 mt-3 mb-5 d-none d-sm-block" />
            <div className="col-12 col-sm-4 text-start d-none d-sm-block">
              {texts.contactForm.title} <br />
              <input
                type="text"
                name="name"
                className="form-control mb-2 mt-4"
                value={contactInfo.name}
                onChange={handleInputChange}
                placeholder={texts.contactForm.name}
              />
              <input
                type="email"
                name="email"
                className="form-control mb-2 mt-3"
                value={contactInfo.email}
                onChange={handleInputChange}
                placeholder={texts.contactForm.email}
              />
            </div>
            <div className="col-12 col-sm-4 d-none d-sm-block">
              <br className="d-none d-sm-block" />
              <textarea
                name="message"
                className="form-control mt-2 mt-sm-4 mb-2"
                style={{ height: '93px' }}
                value={contactInfo.message}
                onChange={handleInputChange}
                placeholder={texts.contactForm.message}
              />
            </div>
            <div className="col-12 col-sm-4 d-none d-sm-block">
              <br className="d-none d-sm-block" />
              {enviando ? (
                <button className="btn btn-dark border-white mt-2 mt-sm-4 w-100" disabled>
                  {texts.contactForm.sending}
                </button>
              ) : (
                <button
                  className="btn btn-dark border-white mt-2 mt-sm-4 w-100"
                  onClick={sendContactMessage}
                >
                  {texts.contactForm.send}
                </button>
              )}
            </div>
          </div>
          <div
            className="text-center pt-4 pb-1"
            style={{
              fontSize: '0.72rem',
              color: 'rgba(255, 255, 255, 0.22)',
              letterSpacing: '0.5px',
              userSelect: 'none',
            }}
          >
            v{packageJson.version}
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
